var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"id":"mainimage","src":require("../assets/Main.jpg")}}),_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('p',[_vm._v(" The website is currently under maintenance. Please visit back at a later date. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }